import { Empty, EmptyActions, EmptyContent, EmptyDescription, EmptyTitle } from '@playbooks/ui/components/empty';
import { EmptyMedia } from '@playbooks/ui/components/empty';
import { Icon, resolveIcon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

import type { FeedbackInternalProps } from './types';

const DropFeedback = ({ density = 'default', icon, title, text, actions, className }: FeedbackInternalProps) => {
	// Theme
	const rootClassName = cn('p-2', className);
	const mediaClassName = cn(density === 'compact' && 'mb-1 size-7 rounded-control [&_svg]:size-3');

	// Render
	return (
		<Empty className={rootClassName}>
			<EmptyContent className='space-y-0.5'>
				{icon && (
					<EmptyMedia className={mediaClassName}>
						<Icon {...resolveIcon(icon, 'fad')} aria-hidden />
					</EmptyMedia>
				)}
				{title && <EmptyTitle>{title}</EmptyTitle>}
				{text && <EmptyDescription>{text}</EmptyDescription>}
				{actions && <EmptyActions className='flex-start pt-3'>{actions}</EmptyActions>}
			</EmptyContent>
		</Empty>
	);
};
export { DropFeedback };
